export default __webpack_public_path__ + "static/media/nf.011002d8.svg";